/// <reference types="vite/client" />

// Alpine
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)

// Store(s)
import { createFilterStore } from './default/stores/filterStore'

document.addEventListener('alpine:init', () => {
    Alpine.store('filterStore', createFilterStore())
})

// Components
import { initHeader } from './default/header'
import { initCollapsible } from './default/collapsible'
import { initIntersectObserver } from './default/intersect-observer'
import { initJSEssentials } from './default/js-essentials'
import { initSlider } from './default/slider'
import { initBasket } from './default/basket'
import { initDialog } from './default/dialog'
import { initFilters } from './default/filters'
import { initFilterBlock } from './default/filterBlock'
import { initRangeSlider } from './default/range-slider'
import { initSelectRangeSlider } from './default/select-range'
import { initVacancyFilter } from './default/vacancyFilter'
import { initVdpImageSlider } from './default/vdp-image-slider'
import { videoEmbedLoader } from './default/video-loader'
import { initSpeculationRules } from './default/speculation-rules'
import { initOnlineafspraken } from './default/online-afspraken.ts'
import { initFinanceTool } from './default/finance-tool'
import { initDatamotiveForms } from './default/datamotive-forms'
initCollapsible()
initHeader()
initIntersectObserver()
initJSEssentials()
initSlider()
initBasket()
initDialog()
initFilters()
initFilterBlock()
initRangeSlider()
initSelectRangeSlider()
initVacancyFilter()
initVdpImageSlider()
videoEmbedLoader()
initSpeculationRules()
initOnlineafspraken()
initFinanceTool()
initDatamotiveForms()
Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        // eslint-disable-next-line no-console
        console.log('HMR')
    })
}
